export default {"src":"/_next/static/media/vault.85337f13.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};